module.exports = __webpack_public_path__ + "static/img/model_img_append.5a020a9f.png";